<div class="hero-employee-dashboard">
  <!-- Quick Actions -->
  <div class="row mb-4">
    <div class="col-12">
      <h2 class="section-title">Quick Actions</h2>
    </div>
    <div class="col-md-4 col-sm-6 mb-3" *ngFor="let action of quickActions">
      <a [routerLink]="action.route" class="action-card">
        <div class="action-icon" [style.background-color]="action.color">
          <i class="fa" [ngClass]="action.icon"></i>
        </div>
        <div class="action-text">
          <div class="action-title">{{ action.title }}</div>
          <div class="action-description">{{ action.description }}</div>
        </div>
      </a>
    </div>
  </div>
</div>
